'use client';

import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { PropsWithChildren } from 'react';

export const FrameContainer = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <Box
      w="full"
      maxW="18.75rem"
      as={motion.div}
      animate={{
        y: ['0%', '-5%', '0%'],
        transition: { duration: 5, ease: 'easeInOut', repeat: Infinity },
      }}
    >
      {children}
    </Box>
  );
};
